import React from 'react';
import { Icon, Link } from '@chakra-ui/react';
import { FaWhatsapp } from 'react-icons/fa';
import { useTranslationsContext } from './useTranslations';

const WHATSAPP_URL = 'https://wa.me/492912025980';

export const WhatsAppButton: React.FC = () => {
  const t = useTranslationsContext();

  return (
    <Link
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label={t.whatsapp_contact}
      title={t.whatsapp_contact}
      position="fixed"
      right={{ base: 4, md: 6 }}
      bottom={{ base: 'calc(env(safe-area-inset-bottom, 0px) + 1rem)', md: 6 }}
      zIndex={900}
      display="inline-flex"
      alignItems="center"
      justifyContent="center"
      boxSize={{ base: 12, md: 14 }}
      borderRadius="full"
      bg="brand"
      color="white"
      boxShadow="0 6px 18px rgba(35, 31, 32, 0.24)"
      transition="transform 160ms ease-out, background-color 160ms ease-out, box-shadow 160ms ease-out"
      _hover={{
        bg: 'red.400',
        color: 'white',
        textDecoration: 'none',
        transform: 'translateY(-2px)',
        boxShadow: '0 8px 22px rgba(35, 31, 32, 0.3)'
      }}
      _active={{
        transform: 'translateY(0)'
      }}
      _focusVisible={{
        outline: '3px solid',
        outlineColor: 'black',
        outlineOffset: '3px'
      }}
    >
      <Icon as={FaWhatsapp} boxSize={{ base: 7, md: 8 }} aria-hidden="true" focusable="false" />
    </Link>
  );
};
